<template>
    <div class="dequeue card">
        <div class="dequeue__title"><i class="far fa-user-check"></i> Students - Out of Queue <span
                v-if="data.length > 0" class="dequeue__count">({{ data.length }})</span></div>
        <div class="card-body">
            <transition name="fade">
                <div v-if="dequeueNotificationStatus" :class="[getDequeueNotificationClass, 'alert']">
                    <i class="far fa-exclamation-circle"></i> {{ dequeueNotificationMessage }}
                </div>
            </transition>
            <div v-if="getDequeueStatus">
                <div v-if="dequeueStatus">
                    <div v-for="user in data" :key="user.username" class="dequeue__item">
                        <dequeue-item :user="user" @refreshQueue="refreshQueue"
                            @setNotificationMessage="setNotificationMessage" :counsellors="counsellorsData"
                            :counsellorsResult="counsellorsResult"></dequeue-item>
                    </div>
                </div>
                <div v-else>
                    <div class="dequeue__message">
                        <div v-if="dequeueAlert == 'success'" class="alert alert-success">
                            <i class="far fa-check"></i> {{ dequeueMessage }}
                        </div>
                        <div v-else-if="dequeueAlert == 'info'" class="alert alert-primary">
                            <i class="far fa-bells"></i> {{ dequeueMessage }}
                        </div>
                        <div v-else class="alert alert-warning">
                            <i class="far fa-exclamation-circle"></i> {{ dequeueMessage }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="dequeue__load">
                <i class="fas fa-spinner fa-spin fa-2x"></i>
            </div>
        </div>
    </div>
</template>

<script>
import DequeueItem from './DeQueueItem';

export default {
    name: 'dequeue',
    components: {
        DequeueItem
    },
    props: {
        counsellorsData: {
            type: Array,
            required: true
        },
        counsellorsResult: {
            type: String,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        message: {
            type: String,
            required: true
        },
        result: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            dequeueNotificationMessage: '',
            dequeueNotificationStatus: false,
            dequeueNotificationTimeout: '',
            dequeueNotificationType: 'success',
            dequeueAlert: 'success',
            dequeueMessage: '',
            dequeueStatus: false
        }
    },
    methods: {
        refreshQueue() {
            this.$emit('refreshQueue');
        },
        setNotificationMessage(alert) {
            const that = this;

            // Set alert
            if (alert.message) {
                this.dequeueNotificationMessage = alert.message;

                // Set type if it exists87 
                if (alert.type) {
                    this.dequeueNotificationType = alert.type;
                }

                // Set alert to true
                this.dequeueNotificationStatus = true;
            }

            // Set timeout
            if (!this.dequeueNotificationTimeout) {
                this.dequeueNotificationTimeout = setTimeout(function () {
                    that.dequeueNotificationStatus = false;
                    that.dequeueNotificationTimeout = '';
                }, 5000);
            }
        }
    },
    computed: {
        getDequeueNotificationClass() {
            return {
                'alert-success': this.dequeueNotificationType == 'success',
                'alert-warning': this.dequeueNotificationType.match(/warning/i),
                'alert-danger': this.dequeueNotificationType.match(/danger/i) || this.dequeueNotificationType == ''
            }
        },
        getDequeueStatus() {
            const that = this;

            // Load handler
            if (this.result) {
                // Success
                if (this.result.match(/ok/i)) {
                    if (this.data.length > 0) {
                        // Set dequeue status
                        this.dequeueStatus = true;
                    } else {
                        // Set alert and message
                        this.dequeueStatus = false;
                        this.dequeueAlert = 'info';
                        this.dequeueMessage = 'There are currently no processed queue items.';
                    }
                } else {
                    // Set alert and message
                    this.dequeueStatus = false;
                    this.dequeueAlert = '';
                    this.dequeueMessage = 'Student dequeue data could not be retrieved. Please contact your system administrator.';
                }

                // Return
                return true;
            } else {
                // Return
                return false;
            }
        }
    }
}
</script>

<style scoped>
.dequeue {
    border: none;
    color: #595d6e;
    -webkit-box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    background-color: #ffffff;
    margin-bottom: 20px;
    border-radius: 4px;
}

.dequeue__count {
    color: #0abb87;
}

.dequeue__item {
    padding-top: .5rem;
    padding-bottom: .5rem;
    border-bottom: 1px dashed #ebedf2;
}

.dequeue__item:last-child {
    border: none;
}

.dequeue__load {
    color: #5d78ff;
    text-align: center;
}

.dequeue__title {
    border-bottom: 1px solid #ebedf2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #48465b;
    font-size: 16px;
    font-weight: 700;
    min-height: 64px;
    padding: 16px 20px;
}

.dequeue__title>i {
    color: #0abb87;
    font-size: 1.25rem;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>